export interface Article {
  id: string;
  slug: string;
  title: string;
  category: string;
  categoryName: string;
  excerpt: string;
  content: string[];
  tags: string[];
  author: string;
  date: string;
  reads: number;
  comments: number;
  cover: string;
  featured?: boolean;
}

export const articles: Article[] = [
  {
    id: "a1",
    slug: "zongmen-pian-mai-luo",
    title: "宗门篇发展脉络全梳理：从入门到宗门之变",
    category: "zongmen",
    categoryName: "宗门篇剧情",
    excerpt: "宗门篇开篇至今的主线推进，从拜入山门的少年意气，到宗门内部暗流涌动，一张时间轴讲清前因后果。",
    content: [
      "宗门篇承载着整部故事世界观真正展开的起点。主角从一介散修身份拜入宗门开始，原本只求安稳的修炼日常，却在一次次历练中逐渐触碰到宗门深藏的秘密。这一篇章的人物密度与势力层次都比开篇更丰富，也由此奠定了后续所有冲突的土壤。",
      "篇章前半段着重铺陈宗门日常：拜师、同门切磋、接取宗门任务、下山历练，节奏明快又带着烟火气。读者在这一段里熟悉了宗门的运转规则，也记住了主角团里每个性格鲜明的角色。这些看似轻松的段落，其实都在为后面的宗门之变埋下伏笔。",
      "随着主线推进，宗门内部的分歧浮出水面。围绕功法传承、资源分配以及一位神秘长老的过往，几股势力逐渐走向对立。主角被迫在师门情谊与心中道义之间做出选择，这段剧情的情感张力是宗门篇最打动人的地方。",
      "从整体结构看，宗门篇可以划分为三个递进的阶段：入门扎根期、历练成长期、内乱抉择期。三个阶段环环相扣，既交代了世界观，又完成了角色的重要成长。理解这条脉络，再看后续主线走向会清晰得多。",
    ],
    tags: ["宗门篇", "主线梳理", "剧情解析"],
    author: "青云门客",
    date: "2026-08-14",
    reads: 12840,
    comments: 326,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20ancient%20sect%20buildings%20nestled%20among%20misty%20mountains%2C%20warm%20cream%20paper%20background%2C%20hand%20drawn%20brush%20strokes%2C%20traditional%20xianxia%20cultivation%20fantasy%20atmosphere%2C%20cinnabar%20red%20rooftops%20with%20soft%20golden%20light&width=800&height=600&seq=article-cover-zongmen-01&orientation=landscape",
    featured: true,
  },
  {
    id: "a2",
    slug: "jianqi-jian-wan-zhang",
    title: "修炼境界体系详解：炼气到飞升每一层都在修什么",
    category: "jingjie",
    categoryName: "修炼境界",
    excerpt: "很多人只记住了境界名称，却搞不清每一层对应的实力变化。这篇把从炼气到大乘的修炼逻辑一条条拆开讲透。",
    content: [
      "修炼境界是理解整部作品战斗力的关键。作者设置的境界阶梯并不只是换一个名头，每一层都对应着不同的体魄、灵气运用方式与寿命上限，人物的行为逻辑也因此合理。",
      "炼气境是根基，讲究筑基固本。这一阶段大多拼的是悟性与勤奋，实力差距不大，胜在功法与临场应变。绝大多数宗门弟子终其一生都停留在这一层，能突破者凤毛麟角。",
      "筑基之后，灵气的运用从粗放转向精妙，招式开始具备个人风格，寿命也随之延长。金丹是公认的分水岭，凝结金丹意味着真正踏入强者之列，也往往成为各方势力争夺与拉拢的对象。",
      "到了元婴与化神，战斗已经从拳脚招式演化为法则层面的交锋，境界高一线，胜算便截然不同。渡劫与大乘更是需要心性与实力兼备的极少数才能触碰的高度。理解这套体系，再回看剧情中每一次越阶而战，都会多一层滋味。",
    ],
    tags: ["修炼境界", "战力体系", "科普向"],
    author: "丹房小童",
    date: "2026-08-16",
    reads: 9620,
    comments: 210,
    cover: "https://readdy.ai/api/search-image?query=Glowing%20golden%20cultivation%20elixir%20orb%20with%20swirling%20energy%20and%20runes%20floating%20above%20an%20open%20palm%2C%20Chinese%20ink%20wash%20style%2C%20warm%20cream%20background%2C%20traditional%20xianxia%20fantasy%2C%20soft%20magical%20light%2C%20minimal%20elegant%20composition&width=800&height=600&seq=article-cover-jingjie-01&orientation=landscape",
    featured: true,
  },
  {
    id: "a3",
    slug: "zhu-xian-zou-xiang",
    title: "主线剧情走向猜想：宗门篇之后，风暴会卷向哪里",
    category: "zhuxian",
    categoryName: "主线剧情",
    excerpt: "宗门篇收束之后，世界的暗线逐渐浮出水面。结合现有伏笔，大胆推演接下来主线的三个可能方向。",
    content: [
      "宗门篇把主角从一座山门带向了更大的舞台，也把埋藏已久的世界暗线掀开一角。随着宗门之变尘埃落定，读者普遍认为故事正进入一个更宏大的转折期。",
      "一个明显的信号是，围绕失传功法与上古遗迹的线索开始频繁出现。这类设定在修仙题材里往往是通往更大格局的钥匙，很可能与主角的身世背景产生直接关联。",
      "另一个值得关注的点是外部势力的登场。宗门篇更多聚焦内部矛盾，而主线若要继续推进，外部修真世家的介入、不同修炼路数之间的碰撞，都可能成为新的冲突引擎。",
      "当然，以上都只是基于现有章节的合理推演，具体走向仍要看作者如何落笔。保持开放心态，或许才能收获更多惊喜。",
    ],
    tags: ["主线剧情", "剧情猜想", "讨论向"],
    author: "断更等更新的阿黎",
    date: "2026-08-12",
    reads: 15320,
    comments: 458,
    cover: "https://readdy.ai/api/search-image?query=Winding%20ancient%20mountain%20path%20leading%20toward%20a%20distant%20misty%20peak%20with%20floating%20islands%2C%20Chinese%20ink%20wash%20painting%2C%20warm%20cream%20and%20golden%20paper%20tone%2C%20traditional%20xianxia%20cultivation%20journey%20atmosphere%2C%20hand%20drawn%20brush%20strokes%2C%20mysterious%20serene%20mood&width=800&height=600&seq=article-cover-zhuxian-01&orientation=landscape",
    featured: true,
  },
  {
    id: "a4",
    slug: "zhu-jue-cheng-chang",
    title: "主角成长弧光盘点：那个曾经平庸的师兄是如何站起来的",
    category: "juese",
    categoryName: "角色志",
    excerpt: "主角从最不起眼的入门弟子到逐步崭露头角，每一次抉择都在重塑他。细数那些让他真正成长的节点。",
    content: [
      "主角一开始并不耀眼，甚至带着点普通人的怯懦与犹豫。正因如此，他的成长才格外有说服力——不是天赋碾压，而是一步步被现实推着做出选择。",
      "第一次明显的转变发生在下山历练中。当他不得不独自面对远超自己实力的对手时，那股为了保护身边人而咬牙坚持的劲头，让读者第一次看到他与过去不同的地方。",
      "进入宗门篇后，主角的成长从外部的实力增长，转向内在的道心稳固。面对师门内外的压力，他逐渐学会在坚守与妥协之间找到平衡，这份成熟远比单纯变强更珍贵。",
      "回看他的成长弧光，会发现每一次跃升都不是凭空而来，而是此前所有挫折的累积。这也正是这个角色最让人共情的地方。",
    ],
    tags: ["主角", "成长弧光", "角色分析"],
    author: "山门扫地僧",
    date: "2026-08-10",
    reads: 8890,
    comments: 167,
    cover: "https://readdy.ai/api/search-image?query=Lone%20robed%20cultivator%20standing%20on%20a%20mountain%20peak%20overlooking%20clouds%2C%20back%20view%2C%20Chinese%20ink%20wash%20painting%2C%20warm%20cream%20background%2C%20traditional%20xianxia%20coming%20of%20age%20journey%2C%20hand%20drawn%20brush%20strokes%2C%20inspiring%20serene%20mood&width=800&height=600&seq=article-cover-juese-01&orientation=landscape",
  },
  {
    id: "a5",
    slug: "zhi-zun-ji-duan",
    title: "原著党视角：宗门篇那些让追更党原地拍桌的名场面",
    category: "zongmen",
    categoryName: "宗门篇剧情",
    excerpt: "不管是爆笑的日常、热血的对决还是催泪的分别，宗门篇名场面实在太多。整理一份让老读者秒懂的回忆杀清单。",
    content: [
      "宗门篇之所以让人念念不忘，很大程度归功于那些让人情绪起伏的名场面。它们像一块块拼图，共同构成了这方世界最鲜活的记忆。",
      "日常向的名场面自然少不了同门之间的插科打诨。某段师兄妹为了一个修炼名额斗嘴又互相关照的桥段，在弹幕区常年霸榜，几乎是整部作品的快乐源泉。",
      "战斗向的名场面则集中在几次关键的越阶之战。主角临阵突破、绝地反击的瞬间，配合分镜的张力，足以让屏幕前的读者握紧拳头。",
      "而最让人破防的，往往是那些无声的告别。宗门篇里某位角色的退场，用极克制的笔触写尽深情，直到今天仍是讨论区的高频泪点话题。",
    ],
    tags: ["宗门篇", "名场面", "情怀向"],
    author: "青云门客",
    date: "2026-08-08",
    reads: 11040,
    comments: 289,
    cover: "https://readdy.ai/api/search-image?query=Two%20young%20cultivators%20in%20robes%20sword%20sparring%20beneath%20a%20traditional%20pagoda%2C%20Chinese%20ink%20wash%20painting%2C%20warm%20cream%20background%2C%20energetic%20xianxia%20daily%20life%2C%20hand%20drawn%20brush%20strokes%2C%20lively%20yet%20elegant%20composition&width=800&height=600&seq=article-cover-zongmen-02&orientation=landscape",
  },
  {
    id: "a6",
    slug: "shen-mi-chang-lao",
    title: "伏笔挖掘：那位神秘长老的身份，可能早就有暗示",
    category: "fubi",
    categoryName: "伏笔盘点",
    excerpt: "宗门篇里看似不起眼的一句台词、一个眼神，可能都在暗示长老的真实身份。带你逐帧回看那些被忽略的细节。",
    content: [
      "追更到一定章节后回看旧章，往往会惊叹作者埋线的手笔。许多当时觉得平常的对话，放到后面再看，竟句句都是伏笔。",
      "以那位身份成谜的长老为例。他初登场时话不多，举动也低调，但作者通过几个微小的动作细节——比如对某件旧物下意识的触碰、提到旧事时一瞬间的停顿——已经悄悄埋下了身份线索。",
      "类似的细节还能在配角的台词里找到。某个不起眼的小角色曾在闲聊中提到过一段往事，当时读者大多一带而过，如今回头再看，恰好能接上长老身世的一条暗线。",
      "这大概就是追更最大的乐趣：前文处处皆草灰蛇线，伏线千里。喜欢推理的读者不妨自己翻回去找找，说不定能比作者更快拼出全貌。",
    ],
    tags: ["伏笔盘点", "细节向", "推理讨论"],
    author: "线索收集员",
    date: "2026-08-06",
    reads: 13210,
    comments: 371,
    cover: "https://readdy.ai/api/search-image?query=Ancient%20mysterious%20scroll%20with%20glowing%20runes%20and%20seal%20on%20a%20wooden%20desk%2C%20Chinese%20ink%20wash%20style%2C%20warm%20cream%20background%2C%20traditional%20xianxia%20mystery%2C%20soft%20candlelight%2C%20hand%20drawn%20brush%20strokes%2C%20intriguing%20detail&width=800&height=600&seq=article-cover-fubi-01&orientation=landscape",
  },
  {
    id: "a7",
    slug: "jin-dan-zhi-men",
    title: "金丹之下皆蝼蚁：境界差距究竟差在哪里",
    category: "jingjie",
    categoryName: "修炼境界",
    excerpt: "为什么总说金丹是一道天堑？从灵气密度、寿元到法则感悟，详细拆解金丹境前后真正的差距。",
    content: [
      "修真界流传着一句话：金丹之下皆蝼蚁。这句话听起来残酷，却在设定上有着充分依据。金丹境不仅是实力的跃升，更是生命本质层面的质变。",
      "首先体现在灵气的质与量上。凝结金丹之后，体内灵气不再是涓涓细流，而是可以形成自我循环的核心，持久作战能力与爆发上限都远超筑基。",
      "其次是对法则的感悟。金丹境修士开始接触天地运行的规律，招式能够牵动天地灵气，这也是许多高阶招式唯有金丹境才能施展的原因。",
      "理解这层差距，就能明白为什么主角每一次越阶而战都如此惊心动魄，也更能体会那些天才人物为何被视为宗门未来的希望。",
    ],
    tags: ["修炼境界", "金丹", "设定解读"],
    author: "丹房小童",
    date: "2026-08-04",
    reads: 7050,
    comments: 143,
    cover: "https://readdy.ai/api/search-image?query=Golden%20inner%20core%20pulsing%20with%20warm%20energy%20inside%20a%20silhouette%20chest%2C%20Chinese%20ink%20wash%20style%2C%20warm%20cream%20background%2C%20traditional%20xianxia%20cultivation%2C%20radiant%20gold%20and%20cinnabar%20accents%2C%20soft%20glow%2C%20minimal%20elegant&width=800&height=600&seq=article-cover-jingjie-02&orientation=landscape",
  },
  {
    id: "a8",
    slug: "tong-men-qing-yi",
    title: "同门情谊线：宗门篇最动人的感情底色",
    category: "juese",
    categoryName: "角色志",
    excerpt: "除了打打杀杀，宗门篇最戳人的其实是同门之间那份相互扶持的情谊。聊聊主角团如何从陌生走向交心。",
    content: [
      "宗门篇的底色并不只有热血与算计，还有一层很暖的同门情谊。主角初入宗门时孤身一人，正是这些来自四面八方的同门，让山门有了家的感觉。",
      "有人是表面毒舌实则嘴硬心软的师姐，有人是一心扑在修炼上的闷葫芦师兄，还有人自带吐槽担当的活宝师弟。每个角色都有鲜明的个性，凑在一起便碰撞出无数令人会心一笑的日常。",
      "这份情谊在危难时刻更加闪光。当宗门陷入危机时，原本各自为政的众人放下成见、并肩作战，那种因为共同守护而凝聚的力量，比任何神功都要动人。",
      "也正因如此，宗门篇里任何一个人的离开都会让人格外难受。这份情感联结，是整个故事最珍贵的部分。",
    ],
    tags: ["同门情谊", "角色志", "温情向"],
    author: "山门扫地僧",
    date: "2026-08-02",
    reads: 6840,
    comments: 121,
    cover: "https://readdy.ai/api/search-image?query=Group%20of%20young%20cultivators%20gathered%20under%20warm%20lantern%20light%20sharing%20a%20meal%20in%20a%20courtyard%2C%20Chinese%20ink%20wash%20painting%2C%20warm%20cream%20and%20amber%20tones%2C%20heartwarming%20xianxia%20friendship%2C%20hand%20drawn%20brush%20strokes%2C%20cozy%20gentle%20mood&width=800&height=600&seq=article-cover-juese-02&orientation=landscape",
  },
  {
    id: "a9",
    slug: "yin-zang-xian-suo",
    title: "那些被忽略的细节：修炼笔记里藏着整条主线",
    category: "fubi",
    categoryName: "伏笔盘点",
    excerpt: "主角无意间得到的修炼笔记，看似普通，实则是串联世界观的关键道具。整理笔记中提到的所有关键线索。",
    content: [
      "一本来历不明的修炼笔记，曾在剧情早期短暂出现过。当时不少读者以为它只是推动主角初期修炼的工具，如今再想，恐怕没这么简单。",
      "笔记里记载的内容看似零散，却多次与主线事件的线索相互印证。比如其中一段对某处上古遗迹的模糊描述，恰好对应了后来出现的地名与布局。",
      "更值得注意的是，笔记作者的身份始终没有明确交代。从字里行间透露的见识来看，此人极可能与故事里最大的谜团有所牵连。",
      "像这样藏在道具里的线索，作品里还有不少。追更时不妨多留个心眼，说不定某个不起眼的小物件，就是解开全局的那把钥匙。",
    ],
    tags: ["伏笔盘点", "关键道具", "细节向"],
    author: "线索收集员",
    date: "2026-07-30",
    reads: 9180,
    comments: 234,
    cover: "https://readdy.ai/api/search-image?query=Old%20cultivation%20notebook%20with%20brush%20calligraphy%20and%20small%20diagrams%20on%20a%20bamboo%20desk%2C%20Chinese%20ink%20wash%20style%2C%20warm%20cream%20background%2C%20traditional%20xianxia%20secret%2C%20soft%20warm%20light%2C%20hand%20drawn%20brush%20strokes%2C%20detailed%20elegant&width=800&height=600&seq=article-cover-fubi-02&orientation=landscape",
  },
  {
    id: "a10",
    slug: "wai-jie-ji-shi",
    title: "外部势力图谱：宗门之外，修真界还有多少方势力",
    category: "zhuxian",
    categoryName: "主线剧情",
    excerpt: "宗门篇结束后，更大的修真世界开始展开。初步梳理目前登场与即将登场的各方势力，帮你建立势力关系地图。",
    content: [
      "宗门篇虽然以一座山门为主要舞台，但透过各种线索，我们早已能窥见更广阔修真世界的一角。整理这些势力的轮廓，有助于看清主线未来的走向。",
      "目前最为明确的是一东一西两大修真世家的存在。它们与宗门保持着微妙的平衡，既有合作也有防备，作者通过几场宗门间的交流已经埋下了博弈的引线。",
      "此外，散修联盟与几处上古遗迹背后的组织也值得关注。这些势力行事低调，却总在关键时刻现身，背后恐怕各自握有不为外人所知的秘密。",
      "把这些势力放在一张地图上，主线未来的风暴中心也就大致清晰了。接下来的章节，很可能会以宗门为支点，撬动整个修真界的格局变化。",
    ],
    tags: ["主线剧情", "势力图", "世界观"],
    author: "断更等更新的阿黎",
    date: "2026-07-28",
    reads: 11760,
    comments: 302,
    cover: "https://readdy.ai/api/search-image?query=Vast%20landscape%20of%20floating%20mountain%20peaks%20and%20distant%20sect%20territories%20under%20warm%20sky%2C%20Chinese%20ink%20wash%20painting%2C%20warm%20cream%20and%20golden%20tone%2C%20traditional%20xianxia%20world%20map%20atmosphere%2C%20hand%20drawn%20brush%20strokes%2C%20grand%20serene%20composition&width=800&height=600&seq=article-cover-zhuxian-02&orientation=landscape",
  },
];